import dynamic from 'next/dynamic';

const Breadcrumbs = dynamic(() => import('@cvent/carina/components/Breadcrumbs').then(module => module.Breadcrumbs));
const TextLink = dynamic(() => import('@cvent/carina/components/TextLink').then(module => module.TextLink));
const Breadcrumb = dynamic(() => import('@cvent/carina/components/Breadcrumbs').then(module => module.Breadcrumb));
const Breakpoints = dynamic(() => import('@cvent/carina/components/Breakpoints').then(module => module.Breakpoints));

export type BreadcrumbProps = {
  name: string;
  href: string;
  isActive?: boolean;
};

type BreadcrumbsProps = {
  breadcrumbs: BreadcrumbProps[];
};

export default function BreadcrumbsContainer({ breadcrumbs }: BreadcrumbsProps) {
  return (
    <Breakpoints m={768}>
      <Breadcrumbs>
        {breadcrumbs.map(breadcrumb => {
          if (breadcrumb.isActive) {
            return (
              <Breadcrumb key={breadcrumb.name}>
                <TextLink href={breadcrumb.href} aria-label={breadcrumb.name}>
                  {breadcrumb.name}
                </TextLink>
              </Breadcrumb>
            );
          }
          return <Breadcrumb key={breadcrumb.name}>{breadcrumb.name}</Breadcrumb>;
        })}
      </Breadcrumbs>
    </Breakpoints>
  );
}
